import React, { useEffect, useState } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// Material UI
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';

// Helpers
import { returnDateAndTime } from 'helpers/date';

// Components
import { TablePlaceholder } from 'components/TablePlaceholder';
import { LineSkeleton } from 'components/LineSkeleton';
import { TableHistoryDatails } from './components';

// Contants
import IMAGES from 'constants/images';
import REPORTS from 'constants/report';
import { REPORTS_TYPES } from 'constants/report';

// Actions
import { setOpen } from 'store/ducks/dialogs/actions';
import * as ReportActions from 'store/ducks/reports/actions';

// Types
import { ApplicationState } from 'store';
import {
  ScheduleInterface,
  ReportScheduleHistoriesInterface,
} from 'store/ducks/reports/types';

// styles
import useStyles from './SubmissionHistory.styles';

interface SubmissionHistoryProps {
  submissionData: ScheduleInterface;
}

type Props = SubmissionHistoryProps;

const SubmissionHistory: React.FC<Props> = ({ submissionData }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [tableIsVisible, setTableIsVisible] = useState(false);
  const [opemDialog, setOpemDialog] = useState(false);
  const [
    reportEntry,
    setReportEntry,
  ] = useState<ReportScheduleHistoriesInterface | null>();
  const isLoading = useSelector(
    (state: ApplicationState) => state.reports.loading,
  );
  const scheduleData = useSelector(
    (state: ApplicationState) => state.reports.scheduleData,
  );

  const handleLoadTable = () => {
    setTableIsVisible(true);

    // dispatch();
  };
  const handleDialog = (schedule: ReportScheduleHistoriesInterface) => {
    if (scheduleData.ReportScheduleHistories) {
      dispatch(
        setOpen({
          open: true,
          maxWidth: 'lg',
          content: (
            <TableHistoryDatails
              setReportEntry={setReportEntry}
              scheduleData={schedule}
              submissionData={submissionData}
              reportEntry={reportEntry!}
            />
          ),
        }),
      );
    }
  };

  const getFilter = (schedule: ScheduleInterface) => {
    let aux = '';
    Object.keys(schedule.filters).forEach(
      (item: string, i: number) =>
        (aux += `${i ? ', ' : ''}${
          REPORTS.FILTERS_GROUPING.find(({ KEY }) => KEY === item)?.VALUE
        }`),
    );
    return aux;
  };

  const getTimeCourse = (schedule: ScheduleInterface) => {
    const result = Math.ceil(schedule.dataInterval / 86400000);
    return result;
  };

  const getGroupings = (schedule: ScheduleInterface) => {
    let aux = '';
    schedule.groupings.forEach(
      (item: string, i: number) =>
        (aux += `${i ? ', ' : ''}${
          REPORTS.FILTERS_GROUPING.find(({ KEY }) => KEY === item)?.VALUE
        }`),
    );
    return aux;
  };

  useEffect(() => {
    dispatch(
      ReportActions.scheduleListRequest({
        reportType: submissionData.reportType,
        _includes: 'history',
        id: submissionData.id,
      }),
    );
  }, []);

  return (
    <Box m={2}>
      {!tableIsVisible && <TablePlaceholder onClick={handleLoadTable} />}
      {tableIsVisible &&
        (!reportEntry ? (
          <TableContainer className={classes.table}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Envio</TableCell>
                  <TableCell>Recorrência</TableCell>
                  <TableCell>Filtros</TableCell>
                  <TableCell>Agrupamentos</TableCell>
                  <TableCell>Destinatários</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!isLoading ? (
                  <>
                    {!!scheduleData.ReportScheduleHistories?.length ? (
                      scheduleData.ReportScheduleHistories.map(
                        (schedule: any, index: number) => (
                          <TableRow>
                            <TableCell>
                              {returnDateAndTime(schedule.createdAt)}
                            </TableCell>
                            <TableCell>
                              {getTimeCourse(schedule) > 1
                                ? 'Últimos' + getTimeCourse(schedule) + 'dias'
                                : 'Último' + getTimeCourse(schedule) + 'dia'}
                            </TableCell>
                            <TableCell>{getFilter(schedule)}</TableCell>
                            <TableCell>{getGroupings(schedule)}</TableCell>
                            <TableCell>
                              {schedule.supervisorIds.length}
                            </TableCell>
                            <TableCell>
                              <Box
                                display='flex'
                                alignItems='center'
                                justifyContent='space-between'
                                maxWidth='128px'>
                                <IconButton>
                                  <img
                                    src={IMAGES.REPORTS_ICONS.DOWNLOAD}
                                    alt='download'
                                  />
                                </IconButton>
                                <IconButton
                                  onClick={() => {
                                    if (
                                      scheduleData.reportType ===
                                        REPORTS_TYPES.ENTRY_VALUE_SIMPLIFIED ||
                                      scheduleData.reportType ===
                                        REPORTS_TYPES.ENTRY_VALUE
                                    ) {
                                      setOpemDialog(true);
                                      setReportEntry(schedule);
                                    } else {
                                      handleDialog(schedule);
                                    }
                                  }}>
                                  <img
                                    src={IMAGES.REPORTS_ICONS.OPEN_REPORTS}
                                    alt='download'
                                  />
                                </IconButton>
                                <IconButton>
                                  <img
                                    src={IMAGES.REPORTS_ICONS.SEND_MENSSAGE}
                                    alt='download'
                                  />
                                </IconButton>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ),
                      )
                    ) : (
                      <TableRow>
                        <TableCell />
                        <TableCell />
                        <TableCell />
                        <TableCell />
                        <TableCell />

                        <TableCell />
                      </TableRow>
                    )}
                  </>
                ) : (
                  <>
                    <TableRow>
                      <TableCell>
                        <LineSkeleton generateCount={12} />
                      </TableCell>
                      <TableCell>
                        <LineSkeleton generateCount={12} />
                      </TableCell>
                      <TableCell>
                        <LineSkeleton generateCount={12} />
                      </TableCell>
                      <TableCell>
                        <LineSkeleton generateCount={12} />
                      </TableCell>
                      <TableCell>
                        <LineSkeleton generateCount={12} />
                      </TableCell>
                      <TableCell>
                        <LineSkeleton generateCount={12} />
                      </TableCell>
                    </TableRow>
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <TableHistoryDatails
            setReportEntry={setReportEntry}
            scheduleData={reportEntry!}
            submissionData={submissionData}
            reportEntry={reportEntry!}
          />
        ))}
    </Box>
  );
};

export { SubmissionHistory };
export default SubmissionHistory;
